import { render, staticRenderFns } from "./AwardedMenu.vue?vue&type=template&id=649806f0&"
import script from "./AwardedMenu.vue?vue&type=script&lang=js&"
export * from "./AwardedMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports